export const formatNumberWithComma = (number?: number | null) => {
  if (number === null || number === undefined) return null;
  const parsed = Number(number);

  if (isNaN(parsed)) return null;
  return new Intl.NumberFormat('en-US').format(parsed);
};
